<!-- Container -->
<div class="container">

  <h2 class="display-3 help-header">
    String or Set or Buoy Number
  </h2>

  <ul>
    <li>
      Identifying code selected by you to track your sets.
      This is numbered by default, but you can change to any name, letter or number of your choosing
      (such as a buoy number or other piece of reference information).
    </li>
  </ul>

  <h2 class="display-3 help-header">
    Set and Retrieval Times, Locations and Depths
  </h2>

  <ul>

    <li class="help-ul">
      <b>
        Bottom Longline:
      </b>
      Create a new set in the app each time you set a longline.
      <ul>
        <li>
          Set Info:
          Record the start date and time, latitude, longitude and depth when you begin setting the longline.
          Record the end latitude, longitude and depth when you get to the end of the line.
        </li>
        <li>
          Retrieve Info:
          Record the end date when you retrieve the longline.
          Record the number of lost skates or tubs from the line.
        </li>
      </ul>
    </li>

    <li class="help-ul">
      <b>
        Pot Gear:
      </b>
      Create a new set in the app each time you set a new string of pots.
      <ul>
        <li>
          Set Info:
          Record the start date and time, latitude, longitude and depth when you begin setting the pots.
          Record the end latitude, longitude and depth when the last pot is deployed.
        </li>
        <li>
          Retrieve Info:
          Record the end date when you retrieve the string of pots.
          Record the number of lost pots for the set.
        </li>
      </ul>
    </li>

    <li class="help-ul">
      <b>
        Other Hook and Line Gear Types:
      </b>
      If you are <i>not</i> using traditional bottom longline or pot gear, then you are not required to record the time and location of each individual set.
      Instead, a set will be defined by generic fishing location, not by each piece of gear set in the water.
      Start recording information for a new set if (A) the vessel moves to a distinguishably different fishing location
      (<i>e.g.</i>, a new reef);
      this is a judgement call made by the fishing crew;
      or (B) the vessel moves to a different fishing location greater than one nautical mile away.

      <ul>
        <li>
          Set Info:
          Record the set date and time, latitude, and longitude when the first hook goes in the water.
          Record the average gear Depth off Bottom (distance from the sea floor to your gear).
        </li>
        <li>
          Retrieve Info:
          Record the retrieval date and time, latitude and longitude when the last hook is pulled for a fishing location.
        </li>
      </ul>

    </li>
  </ul>

  <h2 class="display-3 help-header">
    Catch Species, Counts and Weights
  </h2>

  <ul>
    <li>
      Record catch and discards for any groundfish species managed under the Pacific Coast Groundfish Fishery Management Plan (FMP).
      Fishers will not be required to record non-groundfish species, either retained or discarded.
    </li>
    <li>
      Catch must be sorted according to standard sector regulations
      (i.e., same sorting requirements used at landing).
    </li>
    <li>
      For each species, record the piece count and estimated weight of retained and released fish.
      Weights are the best estimate of the fisher; scale weight accuracy is not expected.
    </li>
  </ul>

  <h2 class="display-3 help-header">
    Landing Date
  </h2>

  <ul>
    <li>
      In most cases, this is the same date as the fish ticket number.
      If you have multiple fish ticket numbers with separate dates, then it should be the earliest date associated with a fish ticket number.
    </li>
  </ul>

</div>
